import React, { Component } from "react";
import "./Main.css";
import { Typography, Button } from "@material-ui/core";
import { TabStrip } from "./TabStrip";
import TicketListing from "./screens/TicketListing";
import ElevatorListing from "./screens/ElevatorListing";
import NotesListing from "./screens/NotesListing";
import ContactsListing from "./screens/ContactsListing";
import InvoiceListing from "./screens/InvoiceListing";
import { isNullOrEmpty } from "./Util";
import { BuildingDialog } from "./BuildingDialog";
import InspectionReports from "./screens/InspectionReports";

export class Building extends Component {
    constructor(props) {
        super(props);
        this.state = {
            BuildingData: null,
            CurrentBuilding: null,
            selectedTab: 0,
            DialogBuilding: null,
            DialogVisible: false,
        };

        if (!isNullOrEmpty(this.props.building)) this.getData();
        this.openDialog = this.openDialog.bind(this);
        this.getData = this.getData.bind(this);
    }
    openDialog(bldg) {
        this.setState({ DialogBuilding: bldg, DialogVisible: true });
    }

    async getData() {
        if (this.props.building) {
            const data = await fetch("Building/GetBuildingData", {
                method: "Post",
                headers: {
                    "Content-Type": "application/json",
                },
                cache: "no-cache",
                body: JSON.stringify({ buildingsId: this.props.building }),
            });
            var res = await data.json();
            this.setState({ BuildingData: res, DialogVisible: false });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.building !== this.props.building) {
            this.getData();
        }
        return false;
    }

    render() {
        var buildingData = this.state.BuildingData || {};
        var tabs = [
            {
                display: "Tickets",
                component: (
                    <TicketListing
                        BuildingID={
                            this.props.building ||
                            "00000000-0000-0000-0000-000000000000"
                        }
                        IsClientPortal={this.props.IsClientPortal}
                    ></TicketListing>
                ),
            },
        ];

        if (!this.props.IsClientPortal) {
            tabs = tabs.concat([
                {
                    display: "Elevators",
                    component: (
                        <ElevatorListing
                            BuildingID={this.props.building}
                        ></ElevatorListing>
                    ),
                },
                {
                    display: "Notes",
                    component: (
                        <NotesListing
                            BuildingID={this.props.building}
                        ></NotesListing>
                    ),
                },
                {
                    display: "Contacts",
                    component: (
                        <ContactsListing
                            BuildingID={this.props.building}
                        ></ContactsListing>
                    ),
                },
            ]);
        } else {
            tabs = tabs.concat([
                {
                    display: "Invoices",
                    component: (
                        <InvoiceListing
                            BuildingID={this.props.building}
                            IsInvoices={true}
                        ></InvoiceListing>
                    ),
                },
                {
                    display: "Estimates",
                    component: (
                        <InvoiceListing
                            BuildingID={this.props.building}
                            IsInvoices={false}
                        ></InvoiceListing>
                    ),
                },
            ]);
        }

        tabs.push({
            display: "Inspection Reports",
            component: (
                <InspectionReports
                    IsClientPortal={this.props.IsClientPortal}
                    BuildingID={this.props.building}
                ></InspectionReports>
            ),
        });

        var selectedPath = document.location.pathname.split("/");
        selectedPath = selectedPath[2];
        var selected = 0;
        switch (selectedPath) {
            case "invoices":
            case "elevators":
                selected = 1;
                break;
            case "proposals":
            case "notes":
                selected = 2;
                break;
            case "contacts":
                selected = 3;
                break;
            case "inspection":
                selected = this.props.IsClientPortal ? 3 : 4;
                break;
            default:
                break;
        }

        return (
            <div
                style={{
                    backgroundColor: "#ebebeb",
                    padding: "4px",
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    maxHeight: "100%",
                }}
            >
                <BuildingDialog
                    BuildingsID={this.state.DialogBuilding}
                    OnClose={this.getData}
                    visible={this.state.DialogVisible}
                ></BuildingDialog>
                <div
                    style={{
                        flex: "1 1 100px",
                        backgroundColor: "white",
                        marginBottom: "4px",
                        padding: "8px",
                    }}
                    className="shadow"
                >
                    {this.state.BuildingData && (
                        <div>
                            <Typography variant="h4">
                                {buildingData.building_name}
                            </Typography>
                            <div style={{ float: "left" }}>
                                <Typography variant="subtitle2">
                                    {buildingData.address1}
                                </Typography>
                                {buildingData.address2 ? (
                                    <Typography variant="subtitle2">
                                        {buildingData.address2}
                                    </Typography>
                                ) : (
                                    ""
                                )}
                                <Typography variant="subtitle2">
                                    {buildingData.city +
                                        ", " +
                                        buildingData.state +
                                        " " +
                                        buildingData.zip}
                                </Typography>
                            </div>
                            <Button
                                onClick={() =>
                                    this.openDialog(this.props.building)
                                }
                                variant="contained"
                                size="small"
                                style={{
                                    marginTop: "4px",
                                    marginLeft: "14px",
                                    float: "left",
                                }}
                                color="primary"
                            >
                                Edit Building
                            </Button>
                        </div>
                    )}
                </div>
                <div
                    style={{
                        flex: "1 1 100%",
                        backgroundColor: "white",
                        display: "flex",
                        overflowY: "auto",
                    }}
                    className="shadow"
                >
                    <TabStrip selected={selected} tabs={tabs}></TabStrip>
                </div>
            </div>
        );
    }
}
